angular.module('picmonicng').component('referralInfo', {
  templateUrl: '/templates/app/components/referral-info/referral-info.html',
  bindings: {},
  controller: [
    '$scope',
    '$state',
    '$cookies',
    'UserService',
    'MarketOptionsConfig',
    'toaster',
    'SalesforceChatService',
    function ($scope, $state, $cookies, UserService, MarketOptionsConfig, toaster, SalesforceChatService) {
      var ctrl = this;

      ctrl.affiliates = $state.current.name === 'app.affiliate' || $state.current.name === 'app.ambassador';
      ctrl.ambassador = $state.current.name === 'app.ambassador';
      ctrl.base_asset_url = window.pls_config.base_asset_url.substring(
        window.pls_config.base_asset_url.indexOf('/cloud_data')
      );
      ctrl.user_count = window.pls_config.user_count;

      if (UserService.user.lead) {
        ctrl.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
      } else if ($cookies.get('pls_user_lead')) {
        ctrl.market = MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead'));
      } else {
        ctrl.market = MarketOptionsConfig.getMarketById(101);
      }

      switch (ctrl.market.id) {
        case 100: // MED
          ctrl.tags =
            '#USMLEStep1 #medicalstudent #medstudent #medstudentproblems #Step1 #USMLE #futuredoctors #futuredoctorsofamerica #futuredoctor #doctorlife #doctorgoals #residency #internalmedicine #doctorsofinstagram #MEDspired #medspiration #MS1';
          break;
        case 103: // Pre-Health
          ctrl.tags = '#prehealth #prehealthstudent #prehealthscience';
          break;
        case 105: // PA
          ctrl.tags =
            '#medschool #medicalstudent #PAschool #physicianassistant #nursingschool #PAstudent #PAsofinstagram #instaPA #futurePA #futurern #futurepa #studyguide #studyhack #studytips #panceprep #PANCE';
          break;
        case 109: // Pharmacy
          ctrl.tags =
            '#pharmacystudent #pharmacystudents #pharmacytechnition #medschool #medstudent #pharmacyschool #pharmacylife #pharmacytech';
          break;
        case 203: // NP
          ctrl.tags =
            '#NP #futureNP #futurenps #npstudent #npschool #scrubs #scrublife #nursinglife #nursingstudent #studyguide\t#studytips #studentnurse';
          break;
        case 115: // PT
          ctrl.tags =
            '#PT #physicaltherapy  #physicaltherapist  #dptstudent #futurept #physicaltherapystudent #ptschool';
          break;
        case 116: // OT
          ctrl.tags =
            '#OT #occupationaltherapy #ots #occupationaltherapist #occupationaltherapystudent #futureOT #nbcot';
          break;
        case 101: // RN & LPN
        case 202:
        default:
          ctrl.tags =
            '#scrubs #scrublife #nursinglife #futurenurse #nursesofinstagram #nursesofIG #nursingschool #nursingstudent #studyguide\t#studytips #futureRN #NCLEX #NCLEXprep #NCLEXstudy #futureLPN #RNstudent #LPNstudent #studentnurse';
          break;
      }

      ctrl.copy = function () {
        toaster.success('Copied', 'Hashtags have been copied to the clipboard.');
      };

      ctrl.downloadResource = function ($event) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent(
            'click',
            (ctrl.affiliates ? 'affiliate-portal' : 'referrals') +
              ' resources downloaded ' +
              angular.element($event.currentTarget).attr('download')
          );
        }
      };

      $scope.$on('youtube.player.playing', function ($event, player) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent(
            'click',
            (ctrl.affiliates ? 'affiliate-portal' : 'referrals') + ' youtube ' + player.getVideoUrl()
          );
        }
      });
    },
  ],
});
